<template>
    <div id="app">

        <div class="retailer-finder__controls">

            <div class="retailer-finder__header">
                <div class="retailer-finder__header-geolocator-col">
                    <div class="retailer-finder__geolocator">
                        <GeoLocator :api-key="apiKey" prefix="Retailers near" @change="locationUpdated" @error="locationError" @not-found="notFound" />
                    </div>
                </div>
            </div>

            <div class="retailer-finder__sources">
                <div v-for="source,idx in sources.available" :key="idx">
                    <label :for="source.source" style="text-transform: capitalize;">
                        <input  @change="locationUpdated()" :id="source.source" type="checkbox" :value="source.source" v-model="sources.requested" />{{source.title}}s
                    </label>
                </div>
            </div>

        </div>

        <div v-if="sharedStore.loading">
            <loader />
        </div>

        <div class="retailer-finder__error error" v-if="errorMessage">{{ errorMessage }}</div>

        <div v-if="initialized && !sharedStore.loading && sharedStore.retailers && sharedStore.retailers.length > 0" id="retailer-view" class="retailer-finder__results" v-cloak>
            <div class="retailer-finder__results-map">
                <RetailersMap :api-key="apiKey" :map-height="height" />
            </div>
            <div v-if="!sharedStore.loading" class="retailer-finder__results-list">
                <transition v-cloak name="smooth">
                    <RetailersList :height="height" />
                </transition>
            </div>
        </div>

        <SchoolsList />
    </div>
</template>

<script>
import GeoLocator from '@bader-rutter/vue/src/components/GeoLocator.vue';
import {store} from './store';
import Loader from './components/Loader';
// import {setTimeout} from 'timers';
import { trackEvent } from './util/tracking';
import RetailersMap from '@/components/RetailersMap';
import RetailersList from '@/components/RetailersList';
import SchoolsList from '@/components/SchoolsList';

export default {
    name: 'RetailerFinder',
    components: {
      GeoLocator,
      Loader,
      RetailersList,
      RetailersMap,
      SchoolsList
    },
    data: () => ({
        sharedStore: store.state,
        //nitrogen maximizers google api key TO DO: get brevant key
        apiKey: 'AIzaSyAodxoCcVOlhZplpIiku7burNsyaNKwsZo',
        initialized: false,
        height: '70vh',
        errorMessage: '',
        locationUpdateCount: 0,
        sources : {
            available : [ 
                { 
                    source : 'agriculture',
                    title : "New Holland Dealer"
                }, 
                { 
                    source : 'construction',
                    title : "CASE Construction Equipment Dealer"
                }, 
                { 
                    source : 'dealers',
                    title : "Case IH Dealer"
                }
            ],
            requested : [ 'agriculture', 'construction', 'dealers' ]
        }
    }),
    methods: {
        locationUpdated(e) {
            e = e || this.sharedStore;
            // only update on first change
            this.locationUpdateCount++;
            if(this.locationUpdateCount >= 2) {
                trackEvent('Retailer location updated', 'update', `${e.location.city} ${e.location.state} ${e.location.zipCode}`)
            }
            const app = this;
            app.errorMessage = '';
            store.setLocation(e.location);
            store
                .setRetailers(e.location.latitude, e.location.longitude, e.location.address, this.sources.requested)
                .then(() => {
                    if (!app.sharedStore.retailers || app.sharedStore.retailers.length === 0) {
                        app.errorMessage = 'No retailers found for your area.';
                    } 
                })
                .catch(e => {
                    console.error('error setting retailers ', e);
                    app.errorMessage = 'Sorry, we could not connect to the server.  Please try again later.';
                });
            app.height = '70vh';
            app.initialized = true;
        },
        locationError(e) {
            this.initialized = true;
            console.error('child geolocator error', e);
            store.timedOut();
            this.height = '0';
            if (/denied|unavailable/gi.test(e.message)) {
                this.errorMessage = 'Please enter your location to find a retailer.';
            } else if (/api/gi.test(e.message)) {
                this.errorMessage = '';
            } else {
                this.errorMessage = 'There was an error.  Make sure you are online.';
            }
        },
        notFound(e) {
            this.initialized = true;
            console.error('child geolocator error', e);
            store.timedOut();
            this.height = '0';
        },
        timedOut() {
            if (!this.initialized) {
                store.timedOut();
                //   this.initialized = true;
                this.height = '0';
                console.error('initialization timeout');
            }
        },
    },
    mounted() {
        // do NOT use an arrow function here
        var app = this;
        setTimeout(function() {
            app.timedOut();
        }, 5000);
    },
}
</script>

<style lang="scss">
[v-cloak] {
    display: none;
}

.smooth-enter-active,
.smooth-leave-active {
    transition: max-height 0.2s ease-out;
    height: auto;
    max-height: 200px;
    opacity: 1;
    overflow: hidden;
}

.smooth-enter,
.smooth-leave-to {
    max-height: 0;
    opacity: 0;
    overflow: hidden;
}
.geolocation {
    &-control__placeSearch input[type='search'] {
        line-height: 1rem;
    }
    &__display {
        font-size: 1rem;

        @media screen and (max-width: 500px) {
            flex-direction: column;

            &-label {
                padding: 0.5rem;
            }
        }
    }
}

.retailer-finder {
    clear: both;

    * {
        box-sizing: border-box;
    }

    &__controls {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        overflow: auto;
        min-width: 500px;
    }

    &__sources {
        display: flex;
        flex-direction: row;
        align-items: center;

        label {
            display: flex;
            margin-right: 1rem;
        }
    }

    &__header {
        display: flex;
        align-items: center;
        width: 100%;
        flex: row wrap;
        justify-content: space-between;
        margin-bottom: 0.25rem;

        @media screen and (max-width: 700px) {
            flex-direction: column;
        }

        &-geolocator-col {
            .geolocation__error-message {
                padding: 0;
            }

            .geolocation__show-form {
                @media screen and (min-width: 700px) {
                    padding-right: 0;
                }
            }
        }
    }

    &__error {
        text-align: center;
        font-size: 0.8rem;
        color: #e6e8ea;;
        padding: 1rem;
        border: #e6e8ea solid 0.25rem;
    }

    p {
        line-height: 1.5;
    }

    &__results {
        display: block;
        flex-direction: row;
        align-items: stretch;
        align-items: flex-start;
        justify-content: flex-start;
        flex-wrap: nowrap;
        margin: 0;
        border: 1px solid #000;
        // background: #007377;
        // padding: 0.25rem;

        &-list {
            overflow-y: scroll;
            width: 39.7%;
        }

        &-map {
            float: right;
            width: 60%;
        }

        @media screen and (max-width: 700px) {
            &-list,
            &-map {
                float: none;
                width: 100%;
                padding-bottom: 5px;
            }
        }
    }

    @media screen and (max-width: 700px) {
        margin: 0 auto;
    }
}
</style>
